// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderTinyPopover__container___wfqK2 {
    --header-popover-height: var(--header-popover-base-height);

    background-color: var(--color-bg-default);
    border-radius: var(--space-xs);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Header/HeaderTinyPopover/HeaderTinyPopover.css"],"names":[],"mappings":"AAAA;IACI,0DAA0D;;IAE1D,yCAAyC;IACzC,8BAA8B;AAClC","sourcesContent":[".container {\n    --header-popover-height: var(--header-popover-base-height);\n\n    background-color: var(--color-bg-default);\n    border-radius: var(--space-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HeaderTinyPopover__container___wfqK2`
};
export default ___CSS_LOADER_EXPORT___;
